import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import { PageBreadcrumb, PageBreadcrumbSegment, PageHeader } from 'components/PageHeader';
import { TotemsList } from './components/TotemsList';

export const Totems = () => {
    return (
        <Container>
            <Helmet title="Totems · TOTADMIN" />
            <PageHeader>
                <PageBreadcrumb>
                    <PageBreadcrumbSegment label="Totems" isCurrent />
                </PageBreadcrumb>
            </PageHeader>
            <Content>
                <ListContainer>
                    <TotemsList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
